<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WhanganuiRiverFlow"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaPutikiWharanui"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.OhotuFlow"></app-basic-cartesian-chart>
